import { PopEntryObject, CallBase, ChatBase } from 'rcx_adapter/src/index';

import { BaseModule } from './BaseModule';
import { DIGITAL_CHANNEL_TYPE, tableNameMap } from '../constants';
import { ModuleBaseOption } from '../interfaces/module';
export interface CreateRecordField {
    name?: string;
    phone?: string;
}

interface ChatBaseWithChannel extends ChatBase {
    channel: string;
    firstName?: string;
    lastName?: string;
}
const EMAIL = {
    Account: (call: ChatBaseWithChannel) => ({ email: call?.edUuid, customer: true }),
    Contact: (call: ChatBaseWithChannel) => ({ email: call?.edUuid }),
    Consumer: (call: ChatBaseWithChannel) => ({ email: call?.edUuid }),
    Case: (call: ChatBaseWithChannel) => ({ u_email: call?.edUuid, contact_type: call?.channel }),
    CaseTask: (call: ChatBaseWithChannel) => ({ u_email: call?.edUuid }),
};
const PHONE = {
    Account: (call: ChatBaseWithChannel) => ({ phone: call?.edUuid, customer: true }),
    Contact: (call: ChatBaseWithChannel) => ({
        phone: call?.edUuid,
        first_name: call?.firstName || '',
        last_name: call?.lastName || '',
    }),
    Consumer: (call: ChatBaseWithChannel) => ({ business_phone: call?.edUuid }),
    Case: (call: ChatBaseWithChannel) => ({ u_phone: call?.edUuid, contact_type: call?.channel }),
    CaseTask: (call: ChatBaseWithChannel) => ({ u_phone: call?.edUuid }),
};
class CreateEntityRecord extends BaseModule<ModuleBaseOption> {
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
        }
    }
    private listenFromRCX() {
        this.mRCXAdapter!.onCreateRecord(this.onPopNewEntity.bind(this));
    }
    parsePhoneForCallBase(data: CallBase) {
        return data.aniE164 || data.ani || '';
    }
    async onPopNewEntity(data: PopEntryObject) {
        const { type } = data;
        const fields = this.generateFields(data);

        const params = Object.entries(fields || {})
            .map(([key, value]) => `${key}=${value}`)
            .join('^');
        this.mServiceNowAdapter!.openFrameOpenServiceNowForm(
            tableNameMap[type as keyof typeof tableNameMap],
            `sys_id=-1&sysparm_query=${params}`
        );
    }
    generateFields(data: PopEntryObject) {
        if (!this.isDigital(data.call)) {
            return this.generateCallFields(data);
        }
        return this.generateDigitalFields(data);
    }
    isDigital(call: any) {
        return Boolean(call?.channelType);
    }
    generateCallFields(data: PopEntryObject) {
        const { type, call } = data;

        const phone: string = this.parsePhoneForCallBase(call);
        const mockCall = {
            edUuid: phone,
            channel: 'phone',
            firstName: call.firstName || call.lead?.firstName,
            lastName: call.lastName || call.lead?.lastName,
        } as ChatBaseWithChannel;
        return PHONE[type as keyof typeof PHONE](mockCall);
    }
    generateDigitalFields(data: PopEntryObject) {
        const call = data.call as ChatBase;
        const type = data.type;
        switch (call.channelType) {
            case DIGITAL_CHANNEL_TYPE.EMAIL:
                return EMAIL[type as keyof typeof EMAIL]({ ...call, channel: 'chat' });
            case DIGITAL_CHANNEL_TYPE.SMS:
            case DIGITAL_CHANNEL_TYPE.WHATS_APP:
                return PHONE[type as keyof typeof PHONE]({ ...call, channel: 'chat' });
            default:
                if (type === 'Account') {
                    return { u_rcx_digital_uuid: call?.edUuid, customer: true };
                } else if (type === 'Case') {
                    return { u_rcx_digital_uuid: call?.edUuid, contact_type: 'chat' };
                } else {
                    return {
                        u_rcx_digital_uuid: call?.edUuid,
                    };
                }
        }
    }
}
export default new CreateEntityRecord();
